// Një departament mund të jetë në disa filiale (`BranchIds`); rreshtat e vjetër
// kanë vetëm `BranchId`. Departamenti pa asnjë filial vlen për të gjitha.

export function departmentBranchIds(d) {
  const ids = Array.isArray(d?.BranchIds) && d.BranchIds.length
    ? d.BranchIds
    : (d?.BranchId ? [d.BranchId] : []);
  return ids.map(String);
}

/** Departamentet që ekzistojnë në filialin e zgjedhur; pa filial → të gjitha. */
export function departmentsForBranch(departments, branchId) {
  const list = Array.isArray(departments) ? departments : [];
  if (branchId === undefined || branchId === null || branchId === '') return list;
  return list.filter((d) => {
    const ids = departmentBranchIds(d);
    return ids.length === 0 || ids.includes(String(branchId));
  });
}
